"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserRole = exports.getIsManager = exports.getIsManagerAndUserId = exports.getManager = exports.getIsTeacher = exports.getUserInfo = exports.getUserTenantId = exports.getUserNickname = exports.getUserId = exports.getUserAuthName = exports.getAccessToken = void 0;
const regist_1 = require("../../../redux/regist");
const getAccessToken = (stateful) => {
    const state = (0, regist_1.toState)(stateful);
    return state['base/account'].token.access_token;
};
exports.getAccessToken = getAccessToken;
const getUserAuthName = (stateful) => {
    const user = (0, exports.getUserInfo)(stateful);
    return user?.auth_name;
};
exports.getUserAuthName = getUserAuthName;
const getUserId = (stateful) => {
    const user = (0, exports.getUserInfo)(stateful);
    return user?.id;
};
exports.getUserId = getUserId;
const getUserNickname = (stateful) => {
    const user = (0, exports.getUserInfo)(stateful);
    return user?.nickname;
};
exports.getUserNickname = getUserNickname;
const getUserTenantId = (stateful) => {
    const user = (0, exports.getUserInfo)(stateful);
    return user?.tenant_id;
};
exports.getUserTenantId = getUserTenantId;
const getUserInfo = (stateful) => {
    const state = (0, regist_1.toState)(stateful);
    return state['base/account'].user;
};
exports.getUserInfo = getUserInfo;
const getIsTeacher = (stateful) => {
    const state = (0, regist_1.toState)(stateful);
    return state['base/account'].isTeacher;
};
exports.getIsTeacher = getIsTeacher;
const getManager = (stateful) => {
    const state = (0, regist_1.toState)(stateful);
    return state['base/account'].manager;
};
exports.getManager = getManager;
const getIsManagerAndUserId = (stateful) => {
    const manager = (0, exports.getManager)(stateful);
    const localId = (0, exports.getUserId)(stateful);
    return manager.includes(localId) ? localId : null;
};
exports.getIsManagerAndUserId = getIsManagerAndUserId;
const getIsManager = (stateful) => {
    const user = (0, exports.getUserInfo)(stateful);
    return user?.role_name === 'admin';
};
exports.getIsManager = getIsManager;
const getUserRole = (stateful) => {
    const user = (0, exports.getUserInfo)(stateful);
    return user?.role_name;
};
exports.getUserRole = getUserRole;
